import React, { useEffect } from "react";
import { Input, Button, Divider, Form, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { putApi } from "redux/sagas/putApiSaga";
import { SERVER_IP } from "assets/Config";
import { API_STATUS } from "constants/app-constants";
import { resetApiStatus } from "redux/reducers/globals/globalActions";
import { postApi } from "redux/sagas/postApiDataSaga";

const { TextArea } = Input;

const AddCity = ({ handleClose, editCity, setCityAddModal }) => {
	const [form] = Form.useForm();
	const globalRedux = useSelector((state) => state?.globalRedux);
	const dispatch = useDispatch();

	const addCity = (values) => {
		let data = {
			...values,
			cityName: values.cityName,
			remarks: values.remarks,
			orgId: globalRedux?.selectedOrganization?._id,
		};
		dispatch(postApi(data, "ADD_CITY"));
	};

	const handleEdit = (values) => {
		let data = {
			...values,
			orgId: globalRedux?.selectedOrganization?._id,
		};
		let url = `${SERVER_IP}city/${editCity._id}?orgId=${globalRedux?.selectedOrganization?._id}`;
		dispatch(putApi(data, "EDIT_CITY", url));
	};

	useEffect(() => {
		if (
			globalRedux.apiStatus.ADD_CITY === "SUCCESS" ||
			globalRedux.apiStatus.EDIT_CITY === "SUCCESS"
		) {
			dispatch(resetApiStatus(editCity ? "EDIT_CITY" : "ADD_CITY"));
			setCityAddModal(false);
			handleClose();
		}
	}, [globalRedux.apiStatus, editCity, setCityAddModal, handleClose, dispatch]);

	const layer1FormCol = {
		labelCol: {
			span: 12,
		},
		wrapperCol: {
			span: 12,
		},
	};

	const loading =
		globalRedux.apiStatus.ADD_CITY === API_STATUS.PENDING ||
		globalRedux.apiStatus.EDIT_CITY === API_STATUS.PENDING;

	return (
		<Row>
			<Col span={24}>
				{/* <Row style={{ backgroundColor: '#fff', padding: '10px 0px' }}>
					<Col>
						<h6 style={{ marginBottom: '0px' }}>{editCity ? 'Edit' : 'New'} City</h6>
					</Col>
				</Row>
				<Divider /> */}
				<Row style={{ paddingTop: 0 }}>
					<Col span={24}>
						<Form
							name="add-city"
							className="required_in_right"
							labelAlign="left"
							form={form}
							onFinish={!editCity ? addCity : handleEdit}
							{...layer1FormCol}
						>
							<Form.Item
								label="City Name"
								name="cityName"
								initialValue={editCity?.cityName}
								rules={[
									{
										required: true,
										message: "This Field is Required!",
									},
								]}
							>
								<Input placeholder="City Name" />
							</Form.Item>
							<Form.Item
								label="Remarks"
								name="remarks"
								initialValue={editCity?.remarks}
							>
								<TextArea />
							</Form.Item>
							<Form.Item
								wrapperCol={{
									offset: 0,
									span: 24,
								}}
							>
								<Row justify="space-between">
									<Button
										onClick={() => setCityAddModal(false)}
										style={{ width: "49%" }}
										danger
									>
										Cancel
									</Button>
									<Button
										loading={loading}
										type="primary"
										style={{ width: "49%", marginRight: 5 }}
										htmlType="submit"
									>
										{editCity ? "Update" : "Create"}
									</Button>
								</Row>
							</Form.Item>
						</Form>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};

export default AddCity;
